const handler = ( $ ) => {
	$( '.services-section .service-item' ).on( 'click', function ( e ) {
		const link = $( this ).find( 'a' ).attr( 'href' );
		if ( link ) {
			window.location.href = link;
		}
	} );
};

export default ( ( $ ) => $( handler ) )( jQuery );
